import { render, staticRenderFns } from "./LexboxCalendarComponent.vue?vue&type=template&id=0879965e&scoped=true&lang=pug"
import script from "./LexboxCalendarComponent.vue?vue&type=script&lang=ts"
export * from "./LexboxCalendarComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexboxCalendarComponent.vue?vue&type=style&index=0&id=0879965e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0879965e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0879965e')) {
      api.createRecord('0879965e', component.options)
    } else {
      api.reload('0879965e', component.options)
    }
    module.hot.accept("./LexboxCalendarComponent.vue?vue&type=template&id=0879965e&scoped=true&lang=pug", function () {
      api.rerender('0879965e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lexbox/LexboxCalendar/LexboxCalendarComponent.vue"
export default component.exports